import { render, staticRenderFns } from "./DynamicFilters.vue?vue&type=template&id=c70493a0"
import script from "./DynamicFilters.vue?vue&type=script&lang=js"
export * from "./DynamicFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports